import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlendState } from 'src/app/shared/types/blend-state.type';
import { environment } from 'src/environments/environment';

const BASE_URL = `${environment.apiConfig.url}/customer-dps`;

@Injectable({
  providedIn: 'root',
})
export class CustomerDPService {
  constructor(private http: HttpClient) {}

  public getBlendState(dpId: string): Observable<BlendState> {
    return this.http.get<BlendState>(`${BASE_URL}/${dpId}/recipe`);
  }
}
